export default "__VITE_ASSET__914ab7a4__$_?nuxt_component=async&nuxt_component_name=SvgoCasting__"